import React, { useState } from 'react';
import { Table, Button, Form, Dropdown, OverlayTrigger, Tooltip, Modal, Offcanvas, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import './MyRole.css';

const MyRole = () => {
    const [showFilter, setShowFilter] = useState(false);
    const [showAddRole, setShowAddRole] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [roleName, setRoleName] = useState('');
    const [roleDescription, setRoleDescription] = useState('');
    const [deleteReason, setDeleteReason] = useState('');
    const [deleteConfirmText, setDeleteConfirmText] = useState('');
    const [selectedRoles, setSelectedRoles] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState(null);
    const [filterUsers, setFilterUsers] = useState(null);

    const userOptions = [
        { value: 'john-doe', label: 'John Doe', avatar: 'JD' },
        { value: 'jane-smith', label: 'Jane Smith', avatar: 'JS' },
        { value: 'mike-johnson', label: 'Mike Johnson', avatar: 'MJ' },
        { value: 'sarah-wilson', label: 'Sarah Wilson', avatar: 'SW' },
        { value: 'david-brown', label: 'David Brown', avatar: 'DB' }
    ];

    const roleOptions = [
        { value: 'frontend-dev', label: 'Frontend Developer' },
        { value: 'backend-dev', label: 'Backend Developer' },
        { value: 'ui-designer', label: 'UI Designer' },
        { value: 'ux-designer', label: 'UX Designer' },
        { value: 'project-manager', label: 'Project Manager' },
        { value: 'team-lead', label: 'Team Lead' },
        { value: 'qa-engineer', label: 'QA Engineer' },
        { value: 'devops-engineer', label: 'DevOps Engineer' }
    ];
    return (
        <div className='c-card-1'>
            <div className='c-card-header-1'>
                <div className='d-flex justify-content-between align-items-center w-100'>
                    <div>
                        Roles
                    </div>
                    <div className='d-flex align-items-center gap-1'>
                        <button 
                            className='btn btn-outline-primary btn-sm me-2 text-nowrap'
                            onClick={() => setShowFilter(true)}
                        >
                            <i className="fas fa-filter me-1"></i>
                            Filter
                        </button>
                        <button 
                            className='btn btn-primary btn-sm text-nowrap'
                            onClick={() => setShowAddRole(true)}
                        >
                            <i className="fas fa-plus me-1"></i>
                            Add Role
                        </button>
                    </div>
                </div>
            </div>
            <div className='c-card-body-1 p-0'>
                <Table responsive className='c-table'>
                    <thead>
                        <tr>
                            <th width="50px" className='text-center'>
                                <Form.Check />
                            </th>
                            <th width="200px">Role Name</th>
                            <th>People</th>
                            <th width="50px" className='text-center'>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[...Array(4)].map((_, i) => (
                        <tr key={i}>
                            <td className='text-center'>
                                <Form.Check />
                            </td>
                            <td>Front End Developer</td>
                            <td>
                                <div className='d-flex align-items-center justify-content-start p-0'>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>John Doe</Tooltip>}
                                    >
                                        <div className='c-avatar c-avatar-text c-avatar-sm me-0'>
                                            JD
                                        </div>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>John Doe</Tooltip>}
                                    >
                                        <div className='c-avatar c-avatar-text c-avatar-sm me-0'>
                                            JD
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </td>
                            <td className='text-center'>
                                <Dropdown className='c-dropdown-1'>
                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                        <i className="fas fa-ellipsis-v"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setShowAddRole(true)}><i className="fas fa-edit me-2"></i> Edit</Dropdown.Item>
                                        <Dropdown.Item onClick={() => setShowDelete(true)}><i className="fas fa-trash me-2"></i> Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            <div className='c-card-footer-1'>
                <div className='d-flex justify-content-between align-items-center c-pagination'>
                    <div class="p-tag d-flex align-items-center text-nowrap">
                        Show
                        <select class="form-select mx-2" style={{ minWidth: 70 }}>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="40">40</option>
                            <option value="50">50</option>
                        </select>
                        per page (20 total)
                    </div>
                    <div className='d-flex align-items-center gap-2 p-tag'>
                        <div className='text-nowrap'>1 to 11 of 20 Pages</div>
                        <select 
                            className='form-select' 
                            style={{ minWidth: 70 }}
                            id='page-select'
                        >
                            {[...Array(4)].map((_, i) => (
                                <option key={i + 1} value={i + 1}>{i + 1}</option>
                            ))}
                        </select>
                        <Button variant="btn">
                            <i className="fas fa-chevron-left"></i>
                        </Button>
                        <Button variant="btn">
                            <i className="fas fa-chevron-right"></i>
                        </Button>
                    </div>
                </div>
            </div>

            {/* Add Role Modal */}
            <Modal show={showAddRole} onHide={() => setShowAddRole(false)} backdrop="static" keyboard={false} centered>
                <Modal.Header closeButton>
                    <Modal.Title className='display-1'>Add Role</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row className='gy-3'>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Role Name <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control 
                                        type="text"
                                        value={roleName}
                                        onChange={(e) => setRoleName(e.target.value)}
                                        placeholder="Enter role name"
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control 
                                        as="textarea"
                                        rows={3}
                                        value={roleDescription}
                                        onChange={(e) => setRoleDescription(e.target.value)}
                                        placeholder="Enter role description"
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Assign Users</Form.Label>
                                    <Select
                                        value={selectedUsers}
                                        onChange={setSelectedUsers}
                                        options={userOptions}
                                        isMulti
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select users..."
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-between'>
                    <Button variant="link" className='text-danger text-decoration-none' onClick={() => {
                        setShowAddRole(false);
                        setRoleName('');
                        setRoleDescription('');
                        setSelectedUsers(null);
                    }}>
                        Cancel
                    </Button>
                    <Button 
                        variant="primary" 
                        onClick={() => {
                            // Add role logic here
                            setShowAddRole(false);
                            setRoleName('');
                            setRoleDescription('');
                            setSelectedUsers(null);
                        }}
                    >
                        Add Role
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Filter Offcanvas */}
            <Offcanvas show={showFilter} onHide={() => setShowFilter(false)} placement="end">
                <Offcanvas.Header className='px-4 py-3' closeButton>
                    <Offcanvas.Title className='display-1'>Filter Roles</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className='px-4 py-3'>
                    <Form>
                        <Row className='gy-3'>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Search Role</Form.Label>
                                    <Select
                                        value={selectedRoles}
                                        onChange={setSelectedRoles}
                                        options={roleOptions}
                                        isMulti
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Search by role..."
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Filter by Users</Form.Label>
                                    <Select
                                        value={filterUsers}
                                        onChange={setFilterUsers}
                                        options={userOptions}
                                        isMulti
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select users..."
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Offcanvas.Body>
                <div className="p-3 border-top">
                    <div className="d-flex justify-content-between">
                        <Button 
                            variant="link" 
                            className='text-decoration-none' 
                            onClick={() => {
                                setSelectedRoles(null);
                                setFilterUsers(null);
                            }}
                        >
                            Reset
                        </Button>
                        <Button 
                            variant="primary" 
                            onClick={() => setShowFilter(false)}
                        >
                            Apply Filters
                        </Button>
                    </div>
                </div>
            </Offcanvas>

            {/* Delete Confirmation Modal */}
            <Modal show={showDelete} onHide={() => setShowDelete(false)} backdrop="static" keyboard={false} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title className='display-1'>Confirmation for Delete Role</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-tag mb-4">
                        Are you sure you want to delete the role <strong>Frontend Developer</strong>? This action cannot be undone.
                    </div>
                    <Form.Group className='mb-4'>
                        <Form.Label>Type <strong className='text-danger'>Delete</strong> to confirm <span className='text-danger'>*</span></Form.Label>
                        <Form.Control 
                            type="text"
                            value={deleteConfirmText}
                            onChange={(e) => setDeleteConfirmText(e.target.value)}
                            placeholder="Type 'Delete' to confirm"
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Reason for deletion <span className='text-danger'>*</span></Form.Label>
                        <Form.Control 
                            as="textarea" 
                            rows={3}
                            value={deleteReason}
                            onChange={(e) => setDeleteReason(e.target.value)}
                            placeholder="Enter reason for deletion"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-between'>
                    <Button 
                        variant="link" 
                        className='text-decoration-none' 
                        onClick={() => {
                            setShowDelete(false);
                            setDeleteConfirmText('');
                            setDeleteReason('');
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        variant="primary" 
                        disabled={deleteConfirmText !== 'Delete' || !deleteReason.trim()}
                        onClick={() => {
                            // Add delete logic here
                            setShowDelete(false);
                            setDeleteConfirmText('');
                            setDeleteReason('');
                        }}
                    >
                        Delete Role
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default MyRole;
